/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_IntervalInputs */

const en_admin_subscriptions_interval = /** @type {(inputs: Admin_Subscriptions_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interval`)
};

const zh_admin_subscriptions_interval = /** @type {(inputs: Admin_Subscriptions_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`周期`)
};

/**
* | output |
* | --- |
* | "Interval" |
*
* @param {Admin_Subscriptions_IntervalInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_interval = /** @type {((inputs?: Admin_Subscriptions_IntervalInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_IntervalInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_subscriptions_interval(inputs)
	return zh_admin_subscriptions_interval(inputs)
});
export { admin_subscriptions_interval as "admin.subscriptions.interval" }